import { FC } from "react";

export const FormWarning: FC<{ message: string }> = ({ message }) => {
  return (
    <div className="ap-warning items-center gap-4 p-4 mb-6">
      <div>
        <span className="Appkit4-icon icon-warning-fill ap-font-40"></span>
      </div>
      <div className="grow">
        <p className="ap-font-medium">Warning</p>
        <p>{message}</p>
      </div>
    </div>)
}
